import React from 'react'
import Header from '../../Header'
import { buttons } from '../../../helpers/const'
import Error from "../../form/error";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = { };
  }

  render() {
    const { currentUser, packages, error, plans, has_subscirption } = this.props;
    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <Header
            buttonText={buttons.plan.text}
            buttonUrl={buttons.plan.url}
            currentUser={currentUser}
          />

          <div className="col-12 md-px3 mx-auto py-110 sm-py4" style={{ maxWidth: '1010px' }}>
            <h2 className="center title mb-30">Choose your package</h2>

            <Error message={error} />

            <div className="flex flex-wrap mxn-25">
              {packages.map(({name, remarks, amount, id, persona_count, media_plan_count}, idx) => (<div key={idx} className="col-4 flex mb-50 px-25 sm-col-12">
                <div className="box-shadow col-12 p2">
                  <div className="border-bottom border-gallery center mb2 pb2">
                    <p className="fs-28 mb2">{name}</p>

                    <p className="h5 mb2">{remarks}</p>

                    <p className="fs-36">{amount}$</p>

                    <a href={`/packages/${id}/checkout`} className="btn btn--primary">Choose Package</a>
                  </div>

                  <ul>
                    <li className="mb2">
                      <i className="far fa-check-circle h3 mr1 text-flirt" />
                      {persona_count} Persona Profile
                    </li>

                    <li className="mb2">
                      <i className="far fa-check-circle h3 mr1 text-flirt" />
                      {media_plan_count} Media Plan Profile
                    </li>
                  </ul>
                </div>
              </div>
              ))}

              {plans.map(({nickname, amount, interval, interval_count, id, metadata}, idx) => (<div key={idx} className="col-4 flex mb-50 px-25 sm-col-12">
                  <div className="box-shadow col-12 p2">
                    <div className="border-bottom border-gallery center mb2 pb2">
                      <p className="fs-28 mb2">{nickname}</p>

                      <p className="h5 mb2">{interval_count} {interval}</p>

                      <p className="h5 mb2">{metadata.remarks}</p>

                      <p className="fs-36">{amount}$</p>

                      {!has_subscirption && <a href={`/subscriptions/${id}/checkout`} className="btn btn--primary">Subscribe</a>}
                    </div>

                    <ul>
                      <li className="mb2">
                        <i className="far fa-check-circle h3 mr1 text-flirt" />
                        unlimited Persona Profile
                      </li>

                      <li className="mb2">
                        <i className="far fa-check-circle h3 mr1 text-flirt" />
                        unlimited Media Plan Profile
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Index
